import dayjs from 'dayjs'

let showTitle = (what, where) => {
  let title = ''
  if (what.length) title = what

  if (where.length) title += ' at ' + where

  if (title === '') return '(Not specified)'

  return title
}

let showPeriod = (period, alternative) => {
  if (alternative.length) return alternative

  if (period === null) return null

  const formatDate = 'MMM YYYY'
  let startDate = dayjs().date(1).format(formatDate)
  let endDate = dayjs().date(1).format(formatDate)

  if (period.startDate.length) startDate = dayjs(period.startDate).date(1).format(formatDate)

  if (period.endDate.length) endDate = dayjs(period.endDate).date(1).format(formatDate)

  if (period.disabled) return null

  if (period.currently) return `${startDate} - Present`

  return `${startDate} - ${endDate}`
}

const ListLevelHeader = ({ what, where, period, alternative }) => {
  return (
    <div>
      <div className="education-header-title">{showTitle(what, where)}</div>
      <div className="education-header-period">{showPeriod(period, alternative)}</div>
    </div>
  )
}

ListLevelHeader.defaultProps = { what: '', where: '', period: null, alternative: '' }
export default ListLevelHeader
